import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const FlowDownstreamWorkbooksWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query FlowDownstreamWorkbooksWithoutPersonalSpaceQuery($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
